<template>
    <div class="user-create">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'usersDetails' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Create User
                        </div>
                    </div>
                </div>
            </div>

            <hr />
        </div>
        
        <div class="container">
            <div class="custom-alert alert alert-success" role="alert" v-if="isSuccess">
                User created successfully.
            </div>

            <div class="custom-alert alert alert-danger" role="alert" v-if="isError">
                Please fill in the mandatory field(s).
            </div>

            <form @submit.prevent="checkForm" action="" method="post">
                <div class="section-personal-details">
                    <div class="mt-5">
                        <ul class="nav custom-tab">
                            <div class="nav-link pointer">Personal Details</div>
                        </ul>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="profile_image">User Photo *</label> 
                                <input id="profile_image" type="file" @change="uploadProfileImage()" hidden>

                                <label :for="profile_image_preview ? '' : 'profile_image'" class="image-upload user-photo" :class="{ 'uploaded': profile_image_preview }" @click="profile_image_preview ? clearProfileImage($event) : ''">
                                    <div class="btn btn-ecdc">{{ profile_image_preview ? 'Remove' : 'Browse' }}</div>
                                    <img v-if="profile_image_preview" :src="profile_image_preview" alt=""> 
                                </label>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.name.$error }">
                                <label for="name">Name *</label> 
                                <input class="form-control" type="text" name="name" id="name" v-model.trim="$v.userData.name.$model">
                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.name.required">Name is required</div>
                            </div>
                         </div>

                         <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.date_of_birth.$error }">
                                <label for="">Birth Date *</label>
                                <datepicker v-model.trim="$v.userData.date_of_birth.$model" format="yyyy-MM-dd"></datepicker>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.date_of_birth.required">Date of birth is required</div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.gender.$error }">
                                <label for="">Gender *</label>
                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input v-model.trim="$v.userData.gender.$model" id="male" type="radio" name="gender" value="0" class="custom-control-input">
                                        <label class="" for="male">Male</label>
                                    </div>

                                    <div class="custom-control-inline pill-radio">
                                        <input v-model.trim="$v.userData.gender.$model" id="female" type="radio" name="gender" value="1" class="custom-control-input">
                                        <label class="" for="female">Female</label>
                                    </div>
                                </div>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.gender.required">Gender is required</div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.email.$error }">
                                <label for="email">Email *</label>
                                <input class="form-control" v-model.trim="$v.userData.email.$model" type="email" name="email" id="email">

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.email.required">Email is required</div>
                                <div class="invalid-feedback form-error-msg" v-if="$v.userData.email.required && !$v.userData.email.emailRegex">Invalid email format</div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.phone.$error }">
                                <label for="phone">Phone *</label>
                                <input class="form-control" v-model.trim="$v.userData.phone.$model" type="tel" name="phone" id="phone">

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.phone.required">Phone is required</div> 
                                <div class="invalid-feedback form-error-msg" v-if="$v.userData.phone.required && !$v.userData.phone.phoneRegex">Invalid phone format</div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.marital_status.$error }">
                                <label for="marital_status">Marital Status *</label>
                                <select class="custom-select form-control" v-model.trim="$v.userData.marital_status.$model"  name="marital_status" id="marital_status">
                                    <option value="0">Single</option>
                                    <option value="4">Anak 0</option>
                                    <option value="1">Anak 1</option>
                                    <option value="2">Anak 2</option>
                                    <option value="3">Anak 3 dan lebih</option>
                                </select>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.marital_status.required">Marital status is required</div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group mb-3" :class="{ 'form-is-error': $v.userData.nric.$error }">
                                <label for="nric">IC No.</label>
                                <input class="form-control" v-model.trim="$v.userData.nric.$model" type="text" name="nric" id="nric">

                                <!-- <div class="invalid-feedback form-error-msg" v-if="!$v.userData.nric.required">ID KTP is required</div>
                                <div class="invalid-feedback form-error-msg" v-if="$v.userData.nric.required  && !$v.userData.nric.nricRegex">IC No. is required</div> -->
                            </div>

                            <div class="form-group">
                                <label for="nric_image">IC Photo</label> 
                                <input id="nric_image" type="file" @change="uploadNricImage()" hidden>

                                <label :for="nric_image_preview ? '' : 'nric_image'" class="image-upload" :class="{ 'uploaded': nric_image_preview }" @click="nric_image_preview ? clearNricImage($event) : ''">
                                    <div class="btn btn-ecdc">{{ nric_image_preview ? 'Remove' : 'Browse' }}</div>
                                    <img v-if="nric_image_preview" :src="nric_image_preview" alt="">                                    
                                </label>
                            </div>
                        </div>

                        <!-- <div class="col-md-3">
                            <div class="form-group mb-3" :class="{ 'form-is-error': $v.userData.kartu_keluarga.$error }">
                                <label for="kartu_keluarga">Kartu Keluarga *</label>
                                <input class="form-control" v-model.trim="$v.userData.kartu_keluarga.$model" type="text" name="kartu_keluarga" id="kartu_keluarga">

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.kartu_keluarga.required">Kartu Keluarga is required</div>
                                <div class="invalid-feedback form-error-msg" v-if="$v.userData.kartu_keluarga.required && !$v.userData.kartu_keluarga.kartuKeluargaRegex">Invalid kartu keluarga format</div>
                            </div>

                            <div class="form-group">
                                <label for="kartu_keluarga_image">Kartu Keluarga Photo</label> 
                                <input id="kartu_keluarga_image" type="file" @change="uploadKartuKeluargaImage()" hidden>

                                <label :for="kartu_keluarga_image_preview ? '' : 'kartu_keluarga_image'" class="image-upload" :class="{ 'uploaded': kartu_keluarga_image_preview }" @click="kartu_keluarga_image_preview ? clearKartuKeluargaImage($event) : ''">
                                    <div class="btn btn-ecdc">{{ kartu_keluarga_image_preview ? 'Remove' : 'Browse' }}</div>
                                    <img v-if="kartu_keluarga_image_preview" :src="kartu_keluarga_image_preview" alt=""> 
                                </label>
                            </div>
                        </div> -->

                        <!-- <div class="col-md-3">
                            <div class="form-group mb-3">
                                <label for="tax_id">NPWP</label> 
                                <input class="form-control" v-model="userData.tax_id" type="text" name="tax_id" id="tax_id">
                            </div>

                            <div class="form-group">
                                <label for="tax_image">NPWP Photo</label> 
                                <input id="tax_image" type="file" @change="uploadTaxImage()" hidden>

                                <label :for="tax_image_preview ? '' : 'tax_image'" class="image-upload" :class="{ 'uploaded': tax_image_preview }" @click="tax_image_preview ? clearTaxImage($event) : ''">
                                    <div class="btn btn-ecdc">{{ tax_image_preview ? 'Remove' : 'Browse' }}</div>
                                    <img v-if="tax_image_preview" :src="tax_image_preview" alt=""> 
                                </label>
                            </div>
                        </div> -->
                    </div>

                    <hr>

                    <div class="form-group" :class="{ 'form-is-error': $v.userData.address.$error }">
                        <label for="address">Address *</label> 
                        <textarea class="form-control" v-model.trim="$v.userData.address.$model" rows="2" name="address" id="address"></textarea>

                        <div class="invalid-feedback form-error-msg" v-if="!$v.userData.address.required">Address is required</div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.division.$error }">
                                <label for="">Division *</label>

                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input v-model.trim="$v.userData.division.$model" type="radio" id="north" name="division" value="0" class="custom-control-input" @change="onChangeDivision()">
                                        <label class="" for="north">East</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input v-model.trim="$v.userData.division.$model" type="radio" id="south" name="division" value="1" class="custom-control-input" @change="onChangeDivision()">
                                        <label class="" for="south">West</label>
                                    </div>
                                </div>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.division.required">Division is required</div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.region_id.$error }">
                                <label for="">Region *</label>

                                <select class="custom-select form-control" v-model.trim="$v.userData.region_id.$model"  name="region" id="region" @change="onChangeRegion()">
                                    <option v-for="region in regionOptions" v-bind:key="region.id" :value="region.id">{{region.name}}</option>
                                </select>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.region_id.required">Region is required</div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.area_id.$error }">
                                <label for="">Primary Area *</label>

                                <div>
                                    <select class="custom-select form-control" v-model.trim="$v.userData.area_id.$model" name="area" id="area">
                                        <option v-for="area in areaOptions" v-bind:key="area.id" :value="area.id">{{area.name}}</option>
                                    </select>
                                </div>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.area_id.required">Primary area is required</div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="bank_acc_image">Photo of Bank book / card (Personal) </label> 
                                <input id="bank_acc_image" type="file" @change="uploadBankAccImage()" hidden>

                                <label :for="bank_acc_image_preview ? '' : 'bank_acc_image'" class="image-upload" :class="{ 'uploaded': bank_acc_image_preview }" @click="bank_acc_image_preview ? clearBankAccImage($event) : ''">
                                    <div class="btn btn-ecdc">{{ bank_acc_image_preview ? 'Remove' : 'Browse' }}</div>
                                    <img v-if="bank_acc_image_preview" :src="bank_acc_image_preview" alt=""> 
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.bank_id.$error }">
                                <label for="">Bank Name (Personal)</label> 
                                <select class="custom-select form-control" v-model.trim="$v.userData.bank_id.$model" name="bank_id" id="bank_id">
                                    <option v-for="bank in banksData" v-bind:key="bank.id" :value="bank.id">{{bank.name}}</option>
                                </select>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.bank_id.required">Bank name is required</div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.bank_beneficiary_name.$error }">
                                <label for="bank_beneficiary_name">Bank Beneficiary Name (Personal)</label> 
                                <input class="form-control" v-model.trim="$v.userData.bank_beneficiary_name.$model" type="text" name="bank_beneficiary_name" id="bank_beneficiary_name">

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.bank_beneficiary_name.required">Bank beneficiary name is required</div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.bank_branch.$error }">
                                <label for="bank_branch">Bank Branch (Personal) </label> 
                                <input class="form-control" v-model.trim="$v.userData.bank_branch.$model" type="text" name="bank_branch" id="bank_branch">

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.bank_branch.required">Bank branch is required</div>
                            </div>
                        </div>
                        
                        <div class="col-md-6">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.bank_acc_no.$error }">
                                <label for="">Bank Account Number (Personal)</label> 
                                <input class="form-control" v-model.trim="$v.userData.bank_acc_no.$model" type="text" name="bank_acc_no" id="bank_acc_no">

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.bank_acc_no.required">Bank account number is required</div>
                            </div>
                        </div>
                    </div>

                    <hr>
                    
                    <div class="form-group">
                        <label for="">Remarks</label>
                        <textarea v-model="userData.remarks" name="remarks" id="remarks" cols="30" rows="3" class="form-control"></textarea>
                    </div>
                </div>
    
                <div class="section-password">
                    <div class="mt-5">
                        <ul class="nav custom-tab">
                            <div class="nav-link pointer">Password</div>
                        </ul>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{ 'form-is-error': $v.userData.password.$error }">
                                <label for="">Password *</label> 
                                <input class="form-control" v-model.trim="$v.userData.password.$model" :type="inputType" name="password" id="password">

                                <div class="invalid-feedback form-error-msg" v-if="!$v.userData.password.required">Password is required</div>
                                <div class="invalid-feedback form-error-msg" v-if="$v.userData.password.required && !$v.userData.password.passwordRegex">Invalid password format</div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{ 'form-is-error': $v.password2.$error }">
                                <label for="">Confirm Password *</label> 
                                <input class="form-control" v-model.trim="$v.password2.$model" :type="inputType" name="password2" id="password2">

                                <div class="invalid-feedback form-error-msg" v-if="!$v.password2.required">Confirm password is required</div>   
                                <div class="invalid-feedback form-error-msg" v-if="$v.password2.required && !$v.password2.sameAsPassword">Confirm password must be same as password</div>

                                <div class="mt-2 form-check custom-control custom-checkbox">
                                    <input @click="changeType" type="checkbox" class="custom-control-input" id="exampleCheck1">
                                    <label class="custom-control-label" for="exampleCheck1">Show Password</label>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
        
                <div class="section-payroll-details" v-if="canModify">
                    <div class="mt-5">
                        <ul class="nav custom-tab">
                            <div class="nav-link pointer">Payroll Details</div>
                        </ul>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Grade</label>
                                <select class="custom-select form-control" v-model="userData.grade"  name="grade" id="grade">
                                    <option value="-">-</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                    <option value="D">D</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="gross_salary">Gross Salary Perday</label>
                                <input class="form-control" v-model="userData.gross_salary" type="tel" name="gross_salary" id="gross_salary">
                            </div>
                        </div>
                    </div>
                    
                    <hr>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="bank_acc_image_payroll">Photo of Bank book / card (Office)</label> 
                                <input id="bank_acc_image_payroll" type="file" @change="uploadBankAccImagePayroll()" hidden>

                                <label :for="bank_acc_image_payroll_preview ? '' : 'bank_acc_image_payroll'" class="image-upload" :class="{ 'uploaded': bank_acc_image_payroll_preview }" @click="bank_acc_image_payroll_preview ? clearBankAccImagePayroll($event) : ''">
                                    <div class="btn btn-ecdc">{{ bank_acc_image_payroll_preview ? 'Remove' : 'Browse' }}</div>
                                    <img v-if="bank_acc_image_payroll_preview" :src="bank_acc_image_payroll_preview" alt=""> 
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Bank Name (Office)</label> 
                                <select class="custom-select form-control" v-model="userData.bank_id_payroll" name="bank_id_payroll" id="bank_id_payroll">
                                    <option v-for="bank in banksData" v-bind:key="bank.id" :value="bank.id">{{bank.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="bank_beneficiary_name">Bank Beneficiary Name (Office)</label> 
                                <input class="form-control" v-model="userData.bank_beneficiary_name_payroll" type="text" name="bank_beneficiary_name_payroll" id="bank_beneficiary_name_payroll">
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="bank_branch">Bank Branch (Office)</label> 
                                <input class="form-control" v-model="userData.bank_branch_payroll" type="text" name="bank_branch_payroll" id="bank_branch_payroll">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Bank Account Number (Office)</label> 
                                <input class="form-control" v-model="userData.bank_acc_no_payroll" type="text" name="bank_acc_no_payroll" id="bank_acc_no_payroll">
                            </div>
                        </div>
                    </div>
                    
                    <hr>   

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Employment Status</label> 
                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input v-model="userData.user_status" id="active" type="radio" name="employment_status" value="0" class="custom-control-input">
                                        <label class="" for="active">Active</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input v-model="userData.user_status" id="resigned" type="radio" name="employment_status" value="1" class="custom-control-input">
                                        <label class="" for="resigned">Resigned</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input v-model="userData.user_status" id="terminated" type="radio" name="employment_status" value="2" class="custom-control-input">
                                        <label class="" for="terminated">Terminated</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">User Type</label> 
                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input v-model="userData.user_type" id="permenant" type="radio" name="user_type" value="0" class="custom-control-input">
                                        <label class="" for="permenant">Permanent</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input v-model="userData.user_type" id="non-permenant" type="radio" name="user_type" value="1"  class="custom-control-input">
                                        <label class="" for="non-permenant">Non Permanent</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="staff_id">Staff Id</label>
                                <input class="form-control" v-model="userData.staff_id" type="text" name="staff_id" id="staff_id">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="">Position</label>
                                <select class="custom-select form-control" v-model="userData.position_id" name="position_id" id="position_id">
                                    <option v-for="position in positionData" :key="position.id" :value="position.id">{{position.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Join Date</label>
                                <datepicker v-model="userData.join_date" format="yyyy-MM-dd"></datepicker>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="">Resign Date</label>
                                <datepicker v-model="userData.resign_date" format="yyyy-MM-dd"></datepicker>

                            </div>
                        </div>
                    </div>
                </div>

                <button type="submit" class="mt-3 btn btn-ecdc btn-shadow">Create</button>
                <button type="button" class="btn btn-link mt-3" @click="$router.push({ name: 'userDetail' });">Cancel</button>

            </form>
        </div>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getAreas, getRegions, getBanks, storeUser, getPositions, checkPermission } from '../api'
import Loader from './Loader.vue'
import Datepicker from 'vuejs-datepicker';
import { required } from 'vuelidate/lib/validators'

export default {
    components: {
        appLoader: Loader,
        Datepicker
    },
    data() {
        return {
            userData: {
                name:"",
                gender:"",
                email:"",
                phone:"",
                nric:"",
                date_of_birth:"",
                marital_status:"",
                kartu_keluarga:"",
                address:"",
                division:"",
                region_id:"",
                area_id:"",
                bank_id:"",
                bank_beneficiary_name:"",
                bank_branch:"",
                bank_acc_no:"",
                tax_id:"",
                remarks:"",
                grade:"",
                gross_salary:"",
                bank_id_payroll:"",
                bank_beneficiary_name_payroll:"",
                bank_branch_payroll:"",
                bank_acc_no_payroll:"",
                user_status: 0,
                user_type:"",
                staff_id:"",
                position_id:"",
                join_date:"",
                resign_date:"",
                password: "",
                profile_image: "",
                nric_image: "",
                kartu_keluarga_image: "",
                tax_image: "",
                bank_acc_image: "",
                bank_acc_image_payroll: ""
            },
            password2: "",
            profile_image_preview: "",
            nric_image_preview: "",
            kartu_keluarga_image_preview: "",
            bank_acc_image_preview: "",
            bank_acc_image_payroll_preview: "",
            tax_image_preview: "",
            areas: "",
            areaOptions: "",
            regions: "",
            regionOptions: "",
            nationalityData: "",
            positionData: "",
            banksData: "",
            defaultAreaId: 0,
            isLoading: true,
            id: 0,
            canModify: false,
            isError: false,
            isSuccess: false,
            inputType: "password"
        }
    },
    validations: {
        userData: {
            name: {
                required
            },
            gender: {
                required
            },
            email: {
                required,
                emailRegex(email) {
                    return(
                        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)
                    );
                }
            },
            phone: {
                required,
                phoneRegex(phone) {
                    return(
                        /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(phone)
                    );
                }
            },
            nric: {
                // nricRegex(nric) {
                //     return(
                //         /^[0-9]+$/.test(nric)
                //     );
                // }
            },
            date_of_birth: {
                required
            },
            marital_status: {
                required
            },
            kartu_keluarga: {
                // required,
                // kartuKeluargaRegex(nric) {
                //     return(
                //         /^[0-9]+$/.test(nric)
                //     );
                // }
            },
            address: {
                required
            },
            division: {
                required
            },
            region_id: {
                required
            },
            area_id: {
                required
            },
            bank_id: {
                // required
            },
            bank_beneficiary_name: {
                // required
            },
            bank_branch: {
                // required
            },
            bank_acc_no: {
                // required
            },
            password: {
                required,
                passwordRegex(password) {
                    return (
                        password.length >= 6
                    );
                } 
            }
        },
        password2: {
            required,
            sameAsPassword(password2) {
                return(
                    password2 == this.userData.password
                )
            }
        }
    },
    async mounted() {
        await this.getBanks();
        await this.getAreas();
        await this.getRegions();
        await this.getPositions();
        this.canModify = await this.checkModifyPermission('modify payroll');

        this.isLoading = false;
    },
    methods: {
        async getAreas() {

            try {
                const result = await getAreas();
                this.areas = result.data.data;
                this.areaOptions = this.areas;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getRegions() {

            try {
                const result = await getRegions(this.id);
                this.regions = result.data.data;
                this.regionOptions = this.regions;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getBanks() {

            try {
                const result = await getBanks(this.id);
                this.banksData = result.data.data;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getPositions() {

            try {
                const result = await getPositions(this.id);
                this.positionData = result.data.data;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async checkModifyPermission(permission) {

            try {
                const result = await checkPermission({permission:permission});
                return result.data.data;
            }
            catch(err) {
                return false;
            }
        },
        async checkForm() {

            const _this = this;

            this.$v.$touch();

            if (this.$v.$invalid) {

                this.isError = true;
                window.scrollTo(0, 0);

                setTimeout(function() { 
                    
                    _this.isError = false;
                }, 2000);
            }
            else {

                this.isLoading = true;

                try {
                    await storeUser(this.userData);

                    this.isSuccess = true;
                    window.scrollTo(0, 0);

                    setTimeout(function() { 
                        
                        _this.isSuccess = false;
                        _this.$router.push({ name: "usersDetails" });
                    }, 2000);
                }
                catch(err) {

                    let errorMsg = "";

                    Object.values(err.response.data.errors).forEach(element => {

                        errorMsg += element + "\n";
                    })
                    alert(errorMsg);
                }

                this.isLoading = false;
            }
        },
        uploadProfileImage() {

            const _this = this;

            const files = document.getElementById("profile_image").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    _this.userData.profile_image = reader.result;
                    _this.profile_image_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                };
            }
        },
        uploadNricImage() {

            const _this = this;
            const files = document.getElementById("nric_image").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    _this.userData.nric_image = reader.result;
                    _this.nric_image_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                };
            }
        },
        uploadKartuKeluargaImage() {

            const _this = this;
            const files = document.getElementById("kartu_keluarga_image").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    _this.userData.kartu_keluarga_image = reader.result;
                    _this.kartu_keluarga_image_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                };
            }
        },
        uploadTaxImage() {

            const _this = this;
            const files = document.getElementById("tax_image").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    _this.userData.tax_image = reader.result;
                    _this.tax_image_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                };
            }
        },
        uploadBankAccImage() {

            const _this = this;
            const files = document.getElementById("bank_acc_image").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    _this.userData.bank_acc_image = reader.result;
                    _this.bank_acc_image_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                };  
            }   
        },
        uploadBankAccImagePayroll() {

            const _this = this;
            const files = document.getElementById("bank_acc_image_payroll").files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    _this.userData.bank_acc_image_payroll = reader.result;
                    _this.bank_acc_image_payroll_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                }; 
            }    
        },
        validationFile(file) {
            
            if(!file.type.startsWith("image")) {

                alert("Please upload image format file.");
            }
            else if(file.size > 3145728) {
                
                alert("Please upload less than 3mb image.");
            }
            else {

                return true;
            }

            return false;
        },
        clearProfileImage(event) {

            event.preventDefault();
            this.userData.profile_image = "";
            this.profile_image_preview = "";
        },
        clearNricImage(event) {

            event.preventDefault();
            this.userData.nric_image = "";
            this.nric_image_preview = "";
        },
        clearKartuKeluargaImage(event) {

            event.preventDefault();
            this.userData.kartu_keluarga_image = "";
            this.kartu_keluarga_image_preview = "";
        },
        clearTaxImage(event) {

            event.preventDefault();
            this.userData.tax_image = "";
            this.tax_image_preview = "";
        },
        clearBankAccImage(event) {

            event.preventDefault();
            this.userData.bank_acc_image = "";
            this.bank_acc_image_preview = "";
        },
        clearBankAccImagePayroll(event) {
            
            event.preventDefault();
            this.userData.bank_acc_image_payroll = "";
            this.bank_acc_image_payroll_preview = "";
        },
        onChangeDivision() {
            
            const _this = this;
            this.regionOptions = [];
            this.userData.region_id = "";
            this.areaOptions = this.areas;
            this.userData.area_id = "";

            if(this.userData.division) {

                const found = this.regions.filter(value => value.division == this.userData.division);

                found.forEach(value => {
                    _this.regionOptions.push(value);
                });
            }
            else {

                this.regionOptions = this.regions;
            }
        },
        onChangeRegion() {
            
            const _this = this;
            this.areaOptions = [];
            this.userData.area_id = "";

            if(this.userData.region_id) {

                const found = this.areas.filter(value => value.region_id == this.userData.region_id);
                
                found.forEach(value => {
                    _this.areaOptions.push(value);
                });
            }
            else {

                this.areaOptions = this.areas;
            }
        },
        changeType(){
            if (this.inputType === "password") {
                this.inputType = "text";
            }else{
                this.inputType = "password";
            }
            
        }
    }
}
</script>